export default __webpack_public_path__ + "static/media/polo-gastronomico.bc89f967.svg";